export const SET_IS_VERIFYING_EMAIL = 'registerEmailVerificationComponent.setIsVerifyingEmail'
export const SET_IS_VERIFIED = 'registerEmailVerificationComponent.setIsVerified'
export const RESET = 'registerEmailVerificationComponent.reset'

export function setIsVerifyingEmail(payload: any) {
  return {
    type: SET_IS_VERIFYING_EMAIL,
    payload
  } as const
}

export function setIsVerified(payload: any) {
  return {
    type: SET_IS_VERIFIED,
    payload
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export type RegisterEmailVerificationAction = ReturnType<
  typeof setIsVerifyingEmail | typeof setIsVerified | typeof reset
>
